import { Component, OnInit } from '@angular/core';
import { DurationService } from '@app/modules/core/services/duration/duration.service';
import { TranslateService } from '@ngx-translate/core';
import { CultureService } from 'src/app/modules/core/services/culture.service';
import { DocumentReader } from 'src/app/modules/core/store/models';

@Component({
    selector: 'app-duration-cell',
    templateUrl: './duration-cell.component.html',
    styleUrls: ['./duration-cell.component.scss'],
    standalone: false
})
export class DurationCellComponent implements OnInit {
  value: any;

  constructor(private translateService: TranslateService, private durationService: DurationService) {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;
    const field = params.schemaField;
    const reader = new DocumentReader(document);

    const data = !!params.data ? reader.getFieldValue(field.systemName) : params.value;

    if (!!!data) {
      this.value = '';
      return;
    }

    this.value = this.durationService.getDurationDisplay(field, data);
  }
}
